var map = {
	"./AUD.png": "./src/assets/imgs/AUD.png",
	"./BRL.png": "./src/assets/imgs/BRL.png",
	"./CAD.png": "./src/assets/imgs/CAD.png",
	"./CHF.png": "./src/assets/imgs/CHF.png",
	"./CLP.png": "./src/assets/imgs/CLP.png",
	"./EUR.png": "./src/assets/imgs/EUR.png",
	"./GBP.png": "./src/assets/imgs/GBP.png",
	"./ImageSend.png": "./src/assets/imgs/ImageSend.png",
	"./JPY.png": "./src/assets/imgs/JPY.png",
	"./USD.png": "./src/assets/imgs/USD.png",
	"./arrow-up.png": "./src/assets/imgs/arrow-up.png",
	"./arrow.png": "./src/assets/imgs/arrow.png",
	"./arrowDown.png": "./src/assets/imgs/arrowDown.png",
	"./arrowUp.png": "./src/assets/imgs/arrowUp.png",
	"./cam-icon.png": "./src/assets/imgs/cam-icon.png",
	"./close.png": "./src/assets/imgs/close.png",
	"./copyIcon.png": "./src/assets/imgs/copyIcon.png",
	"./delete.png": "./src/assets/imgs/delete.png",
	"./down.png": "./src/assets/imgs/down.png",
	"./downloadIcon.png": "./src/assets/imgs/downloadIcon.png",
	"./eye.png": "./src/assets/imgs/eye.png",
	"./eyeHide.png": "./src/assets/imgs/eyeHide.png",
	"./filter.png": "./src/assets/imgs/filter.png",
	"./google.png": "./src/assets/imgs/google.png",
	"./ico-higher-titulo-branco.png": "./src/assets/imgs/ico-higher-titulo-branco.png",
	"./iconMoney.png": "./src/assets/imgs/iconMoney.png",
	"./iconPendInfo.png": "./src/assets/imgs/iconPendInfo.png",
	"./infoIcon.png": "./src/assets/imgs/infoIcon.png",
	"./infoIconDiscount.png": "./src/assets/imgs/infoIconDiscount.png",
	"./inputDoc.png": "./src/assets/imgs/inputDoc.png",
	"./inputDocVerse.png": "./src/assets/imgs/inputDocVerse.png",
	"./limitPayment.png": "./src/assets/imgs/limitPayment.png",
	"./logo-branco.png": "./src/assets/imgs/logo-branco.png",
	"./logo-branco2.png": "./src/assets/imgs/logo-branco2.png",
	"./logo-green.png": "./src/assets/imgs/logo-green.png",
	"./logo-green@2x.png": "./src/assets/imgs/logo-green@2x.png",
	"./logo.png": "./src/assets/imgs/logo.png",
	"./logoRemessa.png": "./src/assets/imgs/logoRemessa.png",
	"./moneyIcon.png": "./src/assets/imgs/moneyIcon.png",
	"./moneyTransfer.png": "./src/assets/imgs/moneyTransfer.png",
	"./more-green.png": "./src/assets/imgs/more-green.png",
	"./more-menu.png": "./src/assets/imgs/more-menu.png",
	"./more.png": "./src/assets/imgs/more.png",
	"./search.png": "./src/assets/imgs/search.png",
	"./shipping1.png": "./src/assets/imgs/shipping1.png",
	"./shipping1Selected.png": "./src/assets/imgs/shipping1Selected.png",
	"./shipping2.png": "./src/assets/imgs/shipping2.png",
	"./shipping2Selected.png": "./src/assets/imgs/shipping2Selected.png",
	"./up.png": "./src/assets/imgs/up.png",
	"./worldwide-green.png": "./src/assets/imgs/worldwide-green.png",
	"./worldwide.png": "./src/assets/imgs/worldwide.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/imgs sync recursive ^\\.\\/.*\\.png$";